import React, { useState, useEffect } from 'react';
import { AccountSummary } from '../../types/portfolio';
import { fetchProfileBalances } from '../../services/profileService';

function formatUSD(n: number) {
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function Balances() {
  const [data, setData] = useState<AccountSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchProfileBalances()
      .then(setData)
      .catch((err: any) => setError(err.message || 'Failed to load balances'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="profile-loading">Loading balances…</div>;
  if (error) return <div className="profile-error">{error}</div>;
  if (!data) return null;

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Account Balances</h3>
      <div className="balance-grid">
        <div className="balance-card">
          <span className="balance-label">Total Balance</span>
          <span className="balance-value">{formatUSD(data.totalBalance)}</span>
        </div>
        <div className="balance-card">
          <span className="balance-label">Available</span>
          <span className="balance-value positive">{formatUSD(data.availableBalance)}</span>
        </div>
        <div className="balance-card">
          <span className="balance-label">Locked</span>
          <span className="balance-value">{formatUSD(data.lockedBalance)}</span>
        </div>
        <div className="balance-card">
          <span className="balance-label">Pending</span>
          <span className="balance-value">{formatUSD(data.pendingBalance)}</span>
        </div>
      </div>
    </div>
  );
}
